
import React from 'react';
import { getParams, end_point } from './helper';
//import HamburgerNavbar from './hamburgerNavbar';
//import { Modal, Label, Col, FormGroup, FormLabel, FormControl, Button, form, Tabs, Tab, Form, InputGroup, Image } from 'react-bootstrap';
// import Footer from './footer'
var $ = require('jquery');


class Logout extends React.Component {
  constructor() {
    super();
    this.state = {
      token: getParams().jwt,
      endpoint: `${end_point('users')}/logout`,
      organization_id: localStorage.getItem('organization_id')
    };
  }

  componentDidMount() {
    console.log('in logout page')
    const rthis = this;
    $.ajax({
      headers: {
        token: this.state.token,
      },
      method: 'PATCH',
      dataType: 'json',
      url: this.state.endpoint,
      success: function (data) {
        window.location.href = document.location.origin + `/login?organization_id=${rthis.state.organization_id}`;
      },
      error: function (data){
        console.log('logging out', data)
        // window.alert('The user does not exist'); // current work around for now for EF2. 
        window.location.href = document.location.origin + `/login?organization_id=${rthis.state.organization_id}`;
      }
    });
  }

  render() {
    return (
          <div></div>
    );
  }
}

export default Logout;
